import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

export default function AlertComponent({
  title,
  body,
  open,
  setOpen,
  agreeTitle,
  disAgreeTitle,
  agreeFunction,
  disAgreeFunction,
  ...props
}) {
  const mainTheme ={
    mainColor:"#1e6a99"
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (disAgreeFunction) {
      disAgreeFunction();
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiPaper-root": {
          padding: "30px",
        },
        '& p,& span,& #alert-dialog-title':{
           fontFamily:'Cairo !important'
        }
      }}
    >
      <DialogTitle  sx={{color:"#000",textAlign:'end'}} id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body}
          {
            props?.hasExtraContent?<Box
              sx={{
                display:'flex',
                alignItems: 'center',
                paddingTop: '20px',
                fontFamily:'Cairo'
              }}
            >
               {props?.extraContent()}
            </Box>:null
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={agreeFunction}
          sx={{
            backgroundColor: mainTheme?.mainColor,
            color: mainTheme?.colorWhite??"#fff",
            fontFamily:'Cairo',
            "&:hover": {
              backgroundColor: mainTheme?.mainColor,
            },
          }}
          autoFocus
        >
          {agreeTitle}
        </Button>
        {disAgreeTitle?.length?<Button
          onClick={handleClose}
          sx={{
            backgroundColor: "#f3f3f3",
            fontFamily:'Cairo',
            "&:hover": {
              backgroundColor: "#f3f3f3",
            },
          }}
        >
          {disAgreeTitle}
        </Button>:null}
        {props?.showCloseButton ? (
          <Box
            sx={{
              width: disAgreeTitle?.length?'60%':"85%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={() => setOpen(false)}
              sx={{
                backgroundColor: "#f3f3f3",
                fontFamily:'Cairo',
                "&:hover": {
                  backgroundColor: "#f3f3f3",
                },
              }}
              autoFocus
            >
              اغلاق
            </Button>
          </Box>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
